import { render, staticRenderFns } from "./ContactFormRecordType.vue?vue&type=template&id=046621cb&scoped=true&"
import script from "./ContactFormRecordType.vue?vue&type=script&lang=ts&"
export * from "./ContactFormRecordType.vue?vue&type=script&lang=ts&"
import style0 from "./ContactFormRecordType.vue?vue&type=style&index=0&id=046621cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046621cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
